export default __webpack_public_path__ + "static/media/level_star_01.b63189e9.svg";